export default "__VITE_ASSET__ci0vuPEW__"